<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { onMounted } from 'vue'
export default {
  name: 'App',
  data() {
    return {
      viewWidth: window.innerWidth,
    }
  },
  mounted() {
    this.$i18n.locale = 'en'
    sessionStorage.setItem('lang', this.$i18n.locale)
  },
}

</script>


<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

ul,
ol {
  list-style: none;
}

a {
  text-decoration: none;
}

html,
body {
  font-family: Arial, Helvetica, sans-serif;
}

#app {
  width: 100%;
  height: 100%;
  color: #1a1a1a;
}
</style>



// WEBPACK FOOTER //
// src/App.vue